import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentOrderRefundsAutomation = (): boolean =>
    useExperimentFlag('enable_order_refunds_automation', 'exp');
